import { CancelButton } from "./SVG";
import { ThankYouPopupProps } from "../types/GamifiedQuiz.type";
import { thanksPopUpTick } from "../../../../assets/assetsSVG";

const ThankYouPopup: React.FC<ThankYouPopupProps> = ({
  setThanksPopup,
  setGamifiedQuiz,
  feedbackContent,
  thanksPopUpFooter,
  footerText,
  GeneralFunctions,
  popUpHead,
  popUpMessage,
  themeManager,
}) => {
  return (
    <div className="thanks-popup-upper-div">
      <div
        className="gamified-thanks-pop-up"
        style={themeManager.getThanksPopupStyles()}
      >
        <div className="gamified-pop-up-cancel-btn-cont">
          <div>
            <div
              onClick={() => {
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_feedback_close_button_clicked",
                  "gamifiedquiz_offline"
                );
                setGamifiedQuiz(false);
                setThanksPopup(false);
              }}
              style={themeManager.getThanksPopUpFooterStyles()}
            >
              {CancelButton(themeManager.getCancelButtonStyles().color)}
            </div>
          </div>
        </div>

        <div className="gamified-pop-up-image-cont">
          {thanksPopUpTick(themeManager.getThanksPopUbIconBackgroundStyle())}
        </div>

        <div className="gamified-pop-up-message-cont">
          <div className="pop-up-message">
            <div
              className="pop-up-message-heading"
              style={themeManager.getThanksPopupHeadingStyles()}
            >
              {feedbackContent?.FeedbackHeading || popUpHead}
            </div>
            <div
              className="pop-up-message-para"
              style={themeManager.getThanksPopupDescriptionStyles()}
            >
              {feedbackContent?.FeedbackDescription || popUpMessage}
            </div>
          </div>
          <div
            className="goto-home"
            style={themeManager.getThanksPopUpGotoHomeStyles()}
            onClick={() => {
              GeneralFunctions.fireTrackingEvent(
                "quest_gamifiedquiz_feedback_gotohome_button_clicked",
                "gamifiedquiz"
              );
              setThanksPopup((prev) => !prev);
            }}
          >
            Go to home!
          </div>
        </div>

        {thanksPopUpFooter ? (
          <div
            className="gamified-quiz-footer-section"
            style={themeManager.getThanksPopUpFooterStyles()}
          >
            {footerText || "Powered by PLG OS"}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ThankYouPopup;
